export const translations = {
  en: {
    // Personal Info
    name: "Berk Pekatik",
    title: "Mid Backend Developer",
    location: "Antalya",
    
    // Profile
    profile: "I am a backend-focused developer experienced in C# and ASP.NET MVC. I follow OOP and SOLID principles to write scalable and maintainable code. I use both .NET Framework and .NET Core, and build APIs using REST and GraphQL. I have experience with Docker, AWS, and Google Cloud Run.",
    
    // Section Titles
    sections: {
      profile: "Profile",
      skills: "Skills",
      projects: "Projects",
      experience: "Experience",
      education: "Education",
      languages: "Languages",
      other: "Other"
    },
    
    // Projects
    projects: [
      {
        title: "EnDrive (EnLog) (May 2025 - Aug 2025)",
        description: "Driver notification system with mobile API for accounting records, earnings tracking, and vehicle cost management.",
        techStack: ".NET CORE 8.0, MSSQL, REST API, N-Tier Architecture"
      },
      {
        title: "SafeTag (July 2024 - Present)",
        description: "Inspection and asset management system for managing company equipment, multilingual content, reminders, and notifications.",
        techStack: "ASP.NET Core, REST API, GraphQL, ElasticSearch, Docker, Google Cloud Run, Autofac, Automapper, N-Tier Architecture"
      },
      {
        title: "S2C (Dec 2020 - Apr 2021)",
        description: "Driver and order tracking system with Google Maps integration, accounting panel, and GraphQL integration with ezcater APIs.",
        techStack: "ASP.NET MVC5, REST API, GraphQL, MySQL, Autofac, Automapper, Repository Pattern"
      },
      {
        title: "HERE-APP (Aug 2019 - Present)",
        description: "Catering application allowing users to order from registered restaurants with live support and virtual POS integration.",
        techStack: "ASP.NET MVC5, MySQL, Paratika POS, Autofac, Automapper, ElasticSearch"
      },
      {
        title: "GRUPYE (Mar 2019 - Oct 2024)",
        description: "Business management system for tracking restaurant activity and internal operations.",
        techStack: "ASP.NET MVC, MySQL, Repository Pattern"
      },
      {
        title: "Medeniyetz",
        description: "Informational web portal with CMS and blog features.",
        techStack: "ASP.NET MVC, SQL Server"
      },
      {
        title: "PHP Admin Panel (2012 - 2013)",
        description: "Server management system with pure PHP (modular architecture) for database CRUD operations and Windows server terminal management through MySQL commands.",
        techStack: "Pure PHP, MySQL, Modular Architecture, Windows Server Management"
      }
    ],
    
    // Experience
    experience: [
      {
        company: "SafeTag",
        position: "Software Developer",
        period: "Dec 2024 - Present"
      },
      {
        company: "Gurpasoft",
        position: "Software Developer",
        period: "Aug 2023 - Aug 2025"
      },
      {
        company: "Kaliru Turizm",
        position: "Software Developer",
        period: "Mar 2022 - Dec 2023"
      },
      {
        company: "Freelancer",
        position: "Software Developer",
        period: "Jun 2018 - Dec 2023"
      },
      {
        company: "Feza Artificial Leather",
        position: "Full Stack Developer",
        period: "Apr 2019 - Apr 2020"
      },
      {
        company: "ARGEYA",
        position: "Intern",
        period: "Jan 2015 - Dec 2015"
      }
    ],
    
    // Education
    education: [
      {
        institution: "Akdeniz University",
        program: "",
        details: "2.72 GPA"
      },
      {
        institution: "Anadolu University",
        program: "",
        details: null
      }
    ],
    
    // Languages
    languageSkills: [
      { language: "Turkish", level: "Native" },
      { language: "English", level: "B1 – Intermediate" }
    ],
    
    // Other
    other: {
      certifications: "Certifications:",
      certification: "Google QGV HG4 B9L",
      hobbies: "Hobbies:",
      hobby: "Playing video games for mental refreshment."
    },
    
    // Tech Stack prefix
    techStackPrefix: "Tech Stack:",
    
    // Loading text
    loadingText: ""
  },
  
  tr: {
    // Personal Info
    name: "Berk Pekatik",
    title: "Orta Seviye Backend Geliştirici",
    location: "Antalya",
    
    // Profile
    profile: "C# ve ASP.NET MVC konusunda deneyimli, backend odaklı bir geliştiriciyim. Ölçeklenebilir ve sürdürülebilir kod yazmak için OOP ve SOLID prensiplerine uyarım. Hem .NET Framework hem de .NET Core kullanırım ve REST ve GraphQL kullanarak API'ler geliştiririm. Docker, AWS ve Google Cloud Run deneyimim bulunmaktadır.",
    
    // Section Titles
    sections: {
      profile: "Profil",
      skills: "Yetenekler",
      projects: "Projeler",
      experience: "Deneyim",
      education: "Eğitim",
      languages: "Diller",
      other: "Diğer"
    },
    
    // Projects
    projects: [
      {
        title: "EnDrive (EnLog) (Mayıs 2025 - Ağustos 2025)",
        description: "Şoför bildirim sistemi, muhasebe kayıtları, kazanç takibi ve araç maliyet yönetimi için mobil API ile.",
        techStack: ".NET CORE 8.0, MSSQL, REST API, N-Katmanlı Mimari"
      },
      {
        title: "SafeTag (Temmuz 2024 - Devam Ediyor)",
        description: "Şirket ekipmanlarını yönetmek, çok dilli içerik, hatırlatmalar ve bildirimler için denetleme ve varlık yönetim sistemi.",
        techStack: "ASP.NET Core, REST API, GraphQL, ElasticSearch, Docker, Google Cloud Run, Autofac, Automapper, N-Katmanlı Mimari"
      },
      {
        title: "S2C (Aralık 2020 - Nisan 2021)",
        description: "Google Maps entegrasyonu, muhasebe paneli ve ezcater API'leri ile GraphQL entegrasyonu olan şoför ve sipariş takip sistemi.",
        techStack: "ASP.NET MVC5, REST API, GraphQL, MySQL, Autofac, Automapper, Repository Pattern"
      },
      {
        title: "HERE-APP (Ağustos 2019 - Devam Ediyor)",
        description: "Kullanıcıların kayıtlı restoranlardan canlı destek ve sanal POS entegrasyonu ile sipariş vermelerini sağlayan catering uygulaması.",
        techStack: "ASP.NET MVC5, MySQL, Paratika POS, Autofac, Automapper, ElasticSearch"
      },
      {
        title: "GRUPYE (Mart 2019 - Ekim 2024)",
        description: "Restoran faaliyetlerini ve iç operasyonları takip etmek için işletme yönetim sistemi.",
        techStack: "ASP.NET MVC, MySQL, Repository Pattern"
      },
      {
        title: "Medeniyetz",
        description: "CMS ve blog özellikleri bulunan bilgilendirici web portalı.",
        techStack: "ASP.NET MVC, SQL Server"
      },
      {
        title: "PHP Admin Paneli (2012 - 2013)",
        description: "MySQL komutlarıyla veritabanı CRUD işlemleri ve Windows sunucu terminal yönetimi için saf PHP (modüler mimari) ile sunucu yönetim sistemi.",
        techStack: "Saf PHP, MySQL, Modüler Mimari, Windows Sunucu Yönetimi"
      }
    ],
    
    // Experience
    experience: [
      {
        company: "SafeTag",
        position: "Yazılım Geliştirici",
        period: "Aralık 2024 - Devam Ediyor"
      },
      {
        company: "Gurpasoft",
        position: "Yazılım Geliştirici",
        period: "Ağustos 2023 - Ağustos 2025"
      },
      {
        company: "Kaliru Turizm",
        position: "Yazılım Geliştirici",
        period: "Mart 2022 - Aralık 2023"
      },
      {
        company: "Serbest Meslek",
        position: "Yazılım Geliştirici",
        period: "Haziran 2018 - Aralık 2023"
      },
      {
        company: "Feza Artificial Leather",
        position: "Full Stack Geliştirici",
        period: "Nisan 2019 - Nisan 2020"
      },
      {
        company: "ARGEYA",
        position: "Stajyer",
        period: "Ocak 2015 - Aralık 2015"
      }
    ],
    
    // Education
    education: [
      {
        institution: "Akdeniz Üniversitesi",
        program: "",
        details: "2.72 GPA"
      },
      {
        institution: "Anadolu Üniversitesi",
        program: "Web Tasarımcısı",
        details: null
      }
    ],
    
    // Languages
    languageSkills: [
      { language: "Türkçe", level: "Ana Dil" },
      { language: "İngilizce", level: "B1 – Orta Seviye" }
    ],
    
    // Other
    other: {
      certifications: "Sertifikalar:",
      certification: "Google QGV HG4 B9L",
      hobbies: "Hobiler:",
      hobby: "Zihinsel rahatlama için video oyunları oynamak."
    },
    
    // Tech Stack prefix
    techStackPrefix: "Teknoloji Yığını:",
    
    // Loading text
    loadingText: "CV Yükleniyor..."
  }
};
